export enum Timeslots {
    H8_10 = "8h - 10h",
    H9_11 = "9h - 11h",
    H10_12 = "10h - 12h",
    H15_17 = "15h - 17h",
    H20_22 = "20h - 22h",
}
